const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

const parts = (iso: string): { year: number, month: number, day: number } | null => {
    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso)

    if (!match) return null

    return { year: Number(match[1]), month: Number(match[2]), day: Number(match[3]) }
}

/**
 * Deterministic date formatting (no locale or time zone), so server and
 * browser always render the same string. 2026-10-28 -> 28 Oct 2026
 */
export const formatDate = (iso: string): string => {
    const date = parts(iso)

    if (!date) return iso

    return `${date.day} ${MONTHS[date.month - 1]} ${date.year}`
}

/** 2026-10-28 -> Oct 2026 */
export const formatMonthYear = (iso: string): string => {
    const date = parts(iso)

    if (!date) return iso

    return `${MONTHS[date.month - 1]} ${date.year}`
}

/** 2026-10-28 -> 2026.10.28, used in lab logs */
export const formatLogDate = (iso: string): string => iso.slice(0, 10).replace(/-/g, '.')

export const padNumber = (value: number, length = 2): string => String(value).padStart(length, '0')

export const pluralize = (count: number, singular: string, plural = `${singular}s`): string => `${count} ${count === 1 ? singular : plural}`
